export default __webpack_public_path__ + "static/media/feature-compare.d01d6833.jpg";